import { IconArrowsRightLeft } from "@tabler/icons-react";
import Image from "next/image";
import { useTranslations } from "next-intl";
import type { ReactNode } from "react";
import ApplePayLogo from "@/assets/icons/payments/apple-pay.png";
import BlikLogo from "@/assets/icons/payments/blik.svg";
import BlikPayLaterLogo from "@/assets/icons/payments/blik-pay-later.svg";
import GooglePayLogo from "@/assets/icons/payments/google-pay.png";

// Brand marks exported from Figma (node 10227:266875). Blik ships as vector;
// Google Pay and Apple Pay are raster, because the design places them as
// images — Apple Pay already carries its own frame, Google Pay does not and
// gets the outlined pill from the design instead.
export const PAYMENT_METHOD_LOGOS: Record<string, ReactNode> = {
  blik: <BlikLogo className="shrink-0" />,
  blikPayLater: <BlikPayLaterLogo className="shrink-0" />,
  googlePay: (
    <span className="flex h-6 w-10 shrink-0 items-center justify-center rounded-full border border-brand-green1-200 bg-white">
      <Image
        alt=""
        className="h-[13px] w-7 object-contain"
        src={GooglePayLogo}
      />
    </span>
  ),
  applePay: <Image alt="" className="h-6 w-auto shrink-0" src={ApplePayLogo} />,
  bankTransfer: (
    <span className="flex h-[22px] w-9 shrink-0 items-center justify-center rounded-[3px] bg-brand-grey2-75">
      <IconArrowsRightLeft
        className="size-3.5 text-brand-black-300"
        stroke={1.5}
      />
    </span>
  ),
};

const PAYMENT_METHODS = [
  "blik",
  "blikPayLater",
  "googlePay",
  "applePay",
  "bankTransfer",
];

export const DietPaymentMethods = () => {
  const t = useTranslations("diets.delivery.paymentMethods");

  return (
    <ul className="mt-3 space-y-4">
      {PAYMENT_METHODS.map((id) => (
        <li className="flex items-center gap-3" key={id}>
          {PAYMENT_METHOD_LOGOS[id]}
          <span className="text-sm">{t(id)}</span>
        </li>
      ))}
    </ul>
  );
};
